<template>
  <div>
    <AuthDetail v-if="isAuth" />
    <div class="py-10 card-detail">
      <v-row class="arrow" @click="toHome">
        <img src="./images/icon.png" alt="" />
      </v-row>
      <v-row>
        <v-card class="card">
          <v-container>
            <v-row v-if="isMobile">
              <v-col align-self="center" class="product-img">
                <v-img :src="currentProduct.url" alt="product" />
                <a
                  :href="currentProduct.productUrl"
                  target="_blank"
                  rel="noopener"
                  class="message"
                  >実際のプロダクトを見る→</a
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="!isMobile" align-self="center" class="product-img">
                <v-img :src="currentProduct.url" alt="product" />
                <a :href="currentProduct.productUrl" class="message"
                  >実際のプロダクトを見る→</a
                >
              </v-col>
              <v-col class="px-5">
                <v-row no-gutters>
                  <v-chip
                    :color="courseTab"
                    label
                    text-color="white"
                    height="24px"
                    width="100px"
                  >
                    {{ currentProduct.course }}
                  </v-chip>
                </v-row>
                <v-row no-gutters class="title">
                  {{ currentProduct.productName }}
                </v-row>
                <v-row no-gutters class="pb-5 detail-explain">
                  {{ productLongEx }}
                </v-row>
                <v-divider />
                <v-row no-gutters class="developer-info">
                  <v-col>
                    <div class="developer-info__wrapper">
                      <h3 class="developer-info__title">教室</h3>
                      <p class="developer-info__text">
                        GeekSalon{{ currentProduct.area }}教室
                      </p>
                    </div>
                    <div class="developer-info__wrapper">
                      <h3 class="developer-info__title">使用スキル</h3>
                      <p class="developer-info__text">
                        <span
                          v-for="(skill, index) in currentProduct.skills"
                          :key="index"
                        >
                          <span v-if="index < currentProduct.skills.length - 1">
                            {{ skill }} /
                          </span>
                          <span v-else> {{ skill }}</span>
                        </span>
                      </p>
                    </div>
                    <div class="developer-info__wrapper">
                      <h3 class="developer-info__title">リリース時期</h3>
                      <p class="developer-info__text">
                        {{ changeDate }}
                      </p>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="developer-info__wrapper">
                      <h3 class="developer-info__title">経験期間</h3>
                      <p class="developer-info__text">
                        {{ currentProduct.experiencePeriod }}
                      </p>
                    </div>
                    <div class="developer-info__wrapper">
                      <h3 class="developer-info__title">大学</h3>
                      <p class="developer-info__text">
                        {{ currentProduct.university }}
                        {{ currentProduct.faculty }}
                        <!-- {{ currentProduct.grade }} -->
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
    </div>
    <CreatorDetail v-if="isCreator" />
  </div>
</template>

<script>
import { isMobile } from "@/lib/functions.js"
import AuthDetail from "@/components/molecules/Admin/AuthDetail.vue"
import CreatorDetail from "@/components/molecules/Admin/CreatorDetail.vue"
import { minpuroproducts } from "../../../firebase.config"
export default {
  name: "CardDetail",
  components: {
    AuthDetail,
    CreatorDetail,
  },
  data() {
    return {
      key: "",
      currentProduct: "",
      dummyWidth: 0,
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize)
    this.$nextTick()
      .then(() => {
        this.key = this.$route.params.id
      })
      .then(() => {
        return minpuroproducts.doc(this.key).get()
      })
      .then((snapshot) => {
        this.currentProduct = {
          ...snapshot.data(),
          creatorName: "",
        }
      })
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    toHome() {
      this.$router.push("/")
    },
    handleResize: function() {
      this.dummyWidth = window.innerWidth
      this.$forceUpdate()
    },
  },

  computed: {
    isMobile: function() {
      this.dummyWidth
      return isMobile()
    },
    courseTab: function() {
      switch (this.currentProduct.course) {
        case "iPhoneアプリ":
          return "#F6982A"
        case "Gameアプリ":
          return "#52B1E8"
        case "Webサービス":
          return "#E8606A"
        case "WebExpert":
          return "#B23B61"
        case "VideoEditor":
          return "#C368ED"
        case "UIUX":
          return "#1CD2AB"
        case "AI":
          return "#BCA820"

        default:
          return "#000000"
      }
    },
    changeDate() {
      if (!this.currentProduct.releasedAt) {
        return 0
      }
      const d = this.currentProduct.releasedAt.toDate()
      const y = d.getFullYear()
      const m = d.getMonth() + 1
      return `${y}年${m}月`
    },
    isAuth() {
      return this.$store.getters.user.isAuth
    },
    isCreator() {
      return (
        this.$store.getters.user.uid !== undefined && // 過去のプロダクトはuserIdを登録していないので、サインインしていない人に対して下の等式が成り立ってしまう
        this.$store.getters.user.uid === this.currentProduct.userId
      )
    },
    productLongEx() {
      if (this.currentProduct) {
        return this.currentProduct.productLongEx.replace(/\\n/g, "\n") // 改行コードを改行に変換
      }
      return ""
    },
  },
}
</script>

<style lang="scss">
.card-detail {
  $mobileWidth: 1024px;
  display: flex;
  justify-items: flex-end;
  @media (max-width: $mobileWidth) {
    flex-direction: column;
  }
  .arrow {
    height: 2rem;
    width: 2rem;
    margin-left: 1rem;
    cursor: pointer;

    @media (max-width: $mobileWidth) {
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    img {
      height: 100%;
      object-fit: contain;
    }
  }

  .card {
    box-shadow: 0px 0px 30px #3c3c3c1a !important;
    border-radius: 10px;
    font-weight: 600;

    @media (max-width: $mobileWidth) {
      border-radius: 0px;
      width: 100%;
    }
  }

  .product-img {
    padding: 0px;
    width: 100%;
    position: relative;
    text-align: center;
    border-radius: 10px;
    margin: 1% 3%;
    overflow: hidden;
    background: #000;

    @media (max-width: $mobileWidth) {
      border-radius: 0px;
    }

    &:hover .v-image {
      opacity: 0.6;
      transition-duration: 0.3s;
    }

    & .v-image {
      cursor: pointer;
      transition-duration: 0.3s;
    }

    & .message {
      position: absolute; /* 絶対位置指定 */
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      width: 100%;
      height: 0;
      display: none;
      color: white;
    }

    &:hover .message {
      display: block;
      transition-duration: 0.3s;
    }
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 20px;
    color: #2d2d2d;
  }

  .detail-explain {
    font-size: 1em;
    font-weight: 100;
    margin-right: 5px;
    margin-top: 12px;
    color: #505050;
    white-space: pre-line; //改行するためのスタイル
  }

  .skill-sets {
    font-size: 1em;
    margin-top: 21px;
    padding-bottom: 20px;
  }

  .developer-info {
    font-size: 0.8em;
    margin-top: 21px;
    color: #505050;
  }

  .developer-info__wrapper {
    padding-bottom: 0.5rem;
  }

  .developer-info__title {
    padding-bottom: 0.5rem;
  }

  .developer-info__text {
    font-weight: 300;
  }
}
</style>
